import ApiService from "@/base/api/api.service"

import {
    GET_FOLLOWER_LIST
} from "@/store/actions.type"

import {
    PUSH_FOLLOWERS,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_USER_URL
} from "@/base/api/config";

const StateKey = 'profileFollowers'

export default {
    async [GET_FOLLOWER_LIST]({ commit, state }, payload) {
        try {
            const res = await ApiService.get(GET_USER_URL,
                `${payload.userId}/followers?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}`)
            commit(PUSH_FOLLOWERS, res.data.users)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}